import React from 'react'

const ThemeIcon = (props) => {
  const height = props.height || 20
  const width = props.width || 20
  const color = props.color || '#202020'
  const strokeWidth = props.strokeWidth || '1'
  return (
    <svg width={width} height={height} viewBox="0 0 30 30" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
      <title>theme</title>
      <g id="admin-UI" stroke="none" strokeWidth={strokeWidth} fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
        <g id="Admin-BOT-UI_branding" transform="translate(-586, -357)" stroke={color}>
          <g id="Group-Copy" transform="translate(577, 348)">
            <g id="theme" transform="translate(11.5, 12.75)">
              <g id="Group" transform="translate(0, 0)">
                <circle id="Oval-Copy-3" cx="14.893163" cy="6.31306053" r="1.50848314"></circle>
                <circle id="Oval-Copy-4" cx="4.18293268" cy="10.8385099" r="1.50848314"></circle>
                <circle id="Oval-Copy-5" cx="6.0685366" cy="5.93593975" r="1.13136235"></circle>
                <circle id="Oval-Copy-6" cx="10.593986" cy="4.42745661" r="1.13136235"></circle>
                <path d="M20.7762472,12.3469931 C19.935745,20.4266085 8.15356707,24.9909256 9.46262367,19.1393931 C9.80124776,17.6257306 9.97502408,16.3585134 9.98395265,15.3377414 L9.98396197,15.3377414 C9.9905639,14.5093406 9.32436428,13.8324371 8.49596346,13.8258352 C8.04293643,13.8222248 7.61254701,14.0235589 7.32496668,14.3736219 C5.30897945,16.8213698 3.58859647,17.4458021 2.16433816,16.2473464 C0.14574365,14.9249716 -3.2086347,4.56910552 7.19989896,0.509143709 C12.833223,-0.951839453 16.9566884,0.731385632 19.5702954,5.55881896" id="Path-2"></path>
                <g id="brush-1558_gHDokiuri" transform="translate(12.3287, 4.1258)">
                  <path d="M12.5517026,0.110559313 C12.4214745,-0.0190273455 12.2171519,-0.036794535 12.0665107,0.0683687155 L12.0454154,0.0683687155 C7.57321217,3.40142588 5.46368231,5.36328864 3.92372552,6.90324543 L5.73792119,8.7385364 C7.27787799,7.19857961 9.23974075,5.08904976 12.5727979,0.616846477 L12.5938932,0.616846477 C12.7114244,0.462142541 12.6932189,0.24367596 12.5517026,0.110559313 L12.5517026,0.110559313 Z" id="Path"></path>
                  <path d="M3.37524776,7.45172319 C2.86844617,7.9585248 2.86844617,8.78021255 3.37524778,9.28701415 C3.88204938,9.79381575 4.70373712,9.79381576 5.21053873,9.28701416 L5.75901649,8.7385364 L3.94482082,6.90324543 L3.37524776,7.45172319 Z" id="Path"></path>
                  <path d="M3.43853366,11.1434004 C3.93368463,10.6482494 3.93368462,9.84545107 3.43853363,9.35030008 C2.94338265,8.8551491 2.14058428,8.85514909 1.64543328,9.35030006 C0.738335448,10.2363026 1.05476493,12.0715936 0,12.388023 C0.99147903,12.3247371 2.42595933,12.1559748 3.43853366,11.1434004 Z" id="Path"></path>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  )
}

export default ThemeIcon





